import script from "./PropertyDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetailView.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetailView.vue?vue&type=style&index=0&id=2175af86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2175af86"]])

export default __exports__